import React, { useState } from "react";

import { Trans, useTranslation } from "react-i18next";
import SwitchButton from "../Buttons/SwitchButton";
import { isEmpty } from "lodash";
import { Collapse } from "react-collapse";
import { X_AXIS_TYPES, Y_AXIS_TYPES, AXIS_TYPES } from "../../utils/constants";

const SpectrumOptionsCollapse = ({
    isWavenumber,
    setIsWavenumber,
    isReflectance,
    setIsReflectance,
    chartPoints,
    setIsLoading,
    setXAxisCheckedReference,
    setYAxisCheckedReference,
}) => {
    const [spectraOptionsOpened, setSpectraOptionsOpened] = useState(true);
    const { t } = useTranslation();

    const handleTabChange = (value, valueSetter, type) => {
        setIsLoading(true);
        valueSetter(value);
        if (type === AXIS_TYPES.X_AXIS)
            setXAxisCheckedReference((prev) => {
                return {
                    ...prev,
                    value: value
                        ? X_AXIS_TYPES.waveNumber
                        : X_AXIS_TYPES.waveLength,
                };
            });
        else
            setYAxisCheckedReference((prev) => {
                return {
                    ...prev,
                    value: value
                        ? Y_AXIS_TYPES.reflectance
                        : Y_AXIS_TYPES.absorbance,
                };
            });
    };
    return (
        <div>
            <div
                className="text-sm cursor-pointer"
                onClick={() => setSpectraOptionsOpened(!spectraOptionsOpened)}
            >
                <div className="px-6 py-3 whitespace-wrap">
                    <div className="flex items-center">
                        <i
                            className={`fas fa-caret-${
                                spectraOptionsOpened ? "down" : "right"
                            } mr-2 color-blue`}
                        />
                        <span className="text-left color-blue font-semibold truncate">
                            <Trans i18nKey="spectraDataOptions">
                                Spectra data options
                            </Trans>
                        </span>
                    </div>
                </div>
            </div>
            <div className="collapse-animation">
                <Collapse isOpened={spectraOptionsOpened}>
                    <div className="px-8 pb-4">
                        <div className="flex justify-around">
                            <div className="flex gap-2">
                                <span className="self-center color-blue text-sm">
                                    X-axis:
                                </span>
                                <SwitchButton
                                    firstButton={`${t("wavenumber")} (cm⁻¹)`}
                                    secondButton={`${t("wavelength")} (nm)`}
                                    isActive={isWavenumber}
                                    setIsActive={(value) =>
                                        handleTabChange(
                                            value,
                                            setIsWavenumber,
                                            AXIS_TYPES.X_AXIS
                                        )
                                    }
                                    disabled={isEmpty(chartPoints)}
                                    greenTheme={true}
                                    entity="chart"
                                />
                            </div>
                            <div className="flex gap-2">
                                <span className="self-center color-blue text-sm">
                                    Y-axis:
                                </span>
                                <SwitchButton
                                    firstButton={t("reflectance")}
                                    secondButton={`${t("absorbance")} (a.u)`}
                                    isActive={isReflectance}
                                    setIsActive={(value) =>
                                        handleTabChange(
                                            value,
                                            setIsReflectance,
                                            AXIS_TYPES.Y_AXIS
                                        )
                                    }
                                    disabled={isEmpty(chartPoints)}
                                    greenTheme={true}
                                    entity="chart"
                                />
                            </div>
                        </div>
                    </div>
                </Collapse>
            </div>
        </div>
    );
};

export default SpectrumOptionsCollapse;
